import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { MST1030_R01Dto, SelectedItemInfo } from './Dto_MST1030_R01';

export type TabType = 'forward' | 'reverse';

export interface MST1030_R01Filter {
    searchText: string;
    searchTextNm: string;
    itemGroup: string;
    itemAccount: string;
}

export const defaultMST1030_R01Filter: MST1030_R01Filter = {
    searchText: "",
    searchTextNm: "",
    itemGroup: "",
    itemAccount: "",
};

export interface Store_MST1030_R01 {
    // 검색 필터
    MST1030_R01Filter: MST1030_R01Filter;
    MST1030_R01PastFilter: MST1030_R01Filter;
    setMST1030_R01Filter: (filter: Partial<MST1030_R01Filter>) => void;
    setMST1030_R01PastFilter: (filter: Partial<MST1030_R01Filter>) => void;

    // 검색 조건에서 선택된 품목 정보 (모달용)
    selectedItemInfo: SelectedItemInfo | undefined;
    setSelectedItemInfo: (itemInfo: SelectedItemInfo | undefined) => void;

    // 탭
    activeTab: TabType;
    setActiveTab: (tab: TabType) => void;

    // 탭별 데이터
    tabData: { forward: MST1030_R01Dto[]; reverse: MST1030_R01Dto[] };
    setTabData: (tab: TabType, data: MST1030_R01Dto[]) => void;

    // 탭별 컬럼 상태
    tabColumnStates: { forward: ColumnState[]; reverse: ColumnState[] };
    setTabColumnState: (tab: TabType, state: ColumnState[]) => void;

    // 탭별 스크롤 위치
    tabScrollTop: { forward: number | null; reverse: number | null };
    setTabScrollTop: (tab: TabType, top: number | null) => void;

    // 선택 관련
    selectedMST1030_R01List: string[];
    setSelectedMST1030_R01List: (idList: string[]) => void;
    addSelectedMST1030_R01List: (idList: string[]) => void;
    removeSelectedMST1030_R01List: (idList?: string[]) => void;
    initSelectedMST1030_R01List: () => void;

    allCount: number;
    setAllCount: (allCount: number) => void;

    initData: () => void;
}

export const useMST1030_R01Store = create<Store_MST1030_R01>((set) => ({
    MST1030_R01Filter: defaultMST1030_R01Filter,
    MST1030_R01PastFilter: defaultMST1030_R01Filter,
    setMST1030_R01Filter: (filter) =>
        set((state) => ({ MST1030_R01Filter: { ...state.MST1030_R01Filter, ...filter } })),
    setMST1030_R01PastFilter: (filter) =>
        set((state) => ({ MST1030_R01PastFilter: { ...state.MST1030_R01PastFilter, ...filter } })),

    selectedItemInfo: undefined,
    setSelectedItemInfo: (itemInfo) => set({ selectedItemInfo: itemInfo }),

    activeTab: 'forward',
    setActiveTab: (tab) => set({ activeTab: tab }),

    tabData: { forward: [], reverse: [] },
    setTabData: (tab, data) =>
        set((state) => ({ tabData: { ...state.tabData, [tab]: data } })),

    tabColumnStates: { forward: [], reverse: [] },
    setTabColumnState: (tab, state) =>
        set((s) => ({ tabColumnStates: { ...s.tabColumnStates, [tab]: state } })),

    tabScrollTop: { forward: null, reverse: null },
    setTabScrollTop: (tab, top) =>
        set((state) => ({ tabScrollTop: { ...state.tabScrollTop, [tab]: top } })),

    selectedMST1030_R01List: [],
    setSelectedMST1030_R01List: (idList) => set({ selectedMST1030_R01List: idList }),
    addSelectedMST1030_R01List: (idList) =>
        set((state) => {
            const next = [...state.selectedMST1030_R01List];
            next.push(...idList.filter((v) => !next.includes(v)));
            return { selectedMST1030_R01List: next };
        }),
    removeSelectedMST1030_R01List: (idList?) =>
        set((state) => ({
            selectedMST1030_R01List: state.selectedMST1030_R01List.filter(
                (v) => (idList ? !idList.includes(v) : false)
            ),
        })),
    initSelectedMST1030_R01List: () => set({ selectedMST1030_R01List: [] }),

    allCount: 0,
    setAllCount: (allCount) => set({ allCount }),

    initData: () =>
        set({
            MST1030_R01Filter: defaultMST1030_R01Filter,
            selectedItemInfo: undefined,
            activeTab: 'forward',
            tabData: { forward: [], reverse: [] },
            tabColumnStates: { forward: [], reverse: [] },
            tabScrollTop: { forward: null, reverse: null },
            selectedMST1030_R01List: [],
            allCount: 0,
        }),
}));

export default useMST1030_R01Store;
